<!-- Иконка перетаскивания: две колонки точек для drag-handle -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M9 5.5H9.01M9 12H9.01M9 18.5H9.01M15 5.5H15.01M15 12H15.01M15 18.5H15.01"
      :stroke="stroke"
      stroke-width="3"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: "GripIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
